module.exports = __webpack_public_path__ + "static/media/crypto_valute.1673d0ef.png";